/* eslint-disable eqeqeq */
import React, { useState } from "react";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEnvelope,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import ContactDetailsPopup from "./ContactDetailsPopup";
import { CalendarCheck, SearchCheck } from "lucide-react";
import moment from "moment";

const ContactActionButton = ({
  id,
  org,
  setEdit,
  setOnlyKyc,
  setContactId,
  toggleShowAddEditContact,
  toggleShowDelete,
  used,
  trustId,
  contact,
  handleSendEmail,
  kycAction,
  amlCTFEnable,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const getNextReviewDate = () => {
    let assessmentDate = contact?.kyc?.risk_assessment?.assessment_date;
    let risk = contact?.kyc?.risk;
    if (!assessmentDate) return "N/A";

    let yearsToAdd = 0;

    if (risk == 0) yearsToAdd = 3;
    else if (risk == 1) yearsToAdd = 1;
    else if (risk == 2) yearsToAdd = 2;
    else return "N/A";

    return moment(assessmentDate, "DD-MM-YYYY")
      .add(yearsToAdd, "years")
      .format("DD-MM-YYYY");
  };
  return (
    <>
      {kycAction ? (
        <span className="flex items-center gap-2 justify-center">
          {contact?.kyc?.risk_assessment && (
            <>
              <CustomTooltip
                message={
                  <div>
                    <p>
                      Assessment Date:{" "}
                      {contact?.kyc?.risk_assessment?.assessment_date}
                    </p>
                    <p>Next Review Date: {getNextReviewDate()}</p>
                  </div>
                }
              >
                <CalendarCheck size={16} />
              </CustomTooltip>
              <span>/</span>
            </>
          )}
          <CustomTooltip message={"Onboarding"}>
            <SearchCheck
              size={16}
              onClick={() => {
                setOnlyKyc(true);
                setEdit(true);
                toggleShowAddEditContact();
                setContactId(id);
              }}
            />
          </CustomTooltip>
        </span>
      ) : (
        <span className="flex items-center gap-2 justify-center">
          {amlCTFEnable ? (
            <>
              {contact?.contact?.email !== null ? (
                <CustomTooltip message={"Email"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      onClick={() => {
                        !contact?.is_reversed && handleSendEmail(contact?.id);
                      }}
                      className={`${
                        contact?.is_reversed
                          ? "opacity-50 cursor-not-allowed "
                          : contact?.consent_mail_sent
                            ? "text-green-600"
                            : ""
                      }`}
                    />
                  </span>
                </CustomTooltip>
              ) : (
                <CustomTooltip message={"Email address missing"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      disabled
                      className={"opacity-50 cursor-not-allowed"}
                    />
                  </span>
                </CustomTooltip>
              )}
              <span>/</span>
            </>
          ) : (
            <></>
          )}
          <CustomTooltip message={"View"}>
            <span>
              <FontAwesomeIcon
                onClick={toggleShowModal}
                icon={faEye}
                size="1x"
                data-toggle="modal"
                data-target="#clientDetail"
              />
            </span>
          </CustomTooltip>
          <span>/</span>
          <CustomTooltip message={"Edit"}>
            <span>
              <FontAwesomeIcon
                icon={faEdit}
                size="1x"
                onClick={() => {
                  setEdit(true);
                  toggleShowAddEditContact();
                  setContactId(id);
                }}
              />
            </span>
          </CustomTooltip>
          {!used && (
            <>
              <span>/</span>
              <CustomTooltip message={"Delete"}>
                <span>
                  <FontAwesomeIcon
                    icon={faTrash}
                    size="1x"
                    onClick={() => {
                      setContactId(id);
                      toggleShowDelete();
                    }}
                  />
                </span>
              </CustomTooltip>
            </>
          )}
        </span>
      )}
      {showView && (
        <ContactDetailsPopup
          showView={showView}
          contactId={id}
          org={org}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
          trustId={trustId}
          contact={contact}
        />
      )}
    </>
  );
};

export default ContactActionButton;
